module.exports = __webpack_public_path__ + "static/media/开户客服@2x.3107aa34.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_171/images/开户客服@2x.png
// module id = 1549
// module chunks = 0